module.exports = __webpack_public_path__ + "static/img/4769_phase_function_Paper_PointsHejduk_Prediction.ef4f35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4769_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tCJu
// module chunks = 0